import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@material-ui/styles';
import { createTheme } from '@material-ui/core';
import { useGTM, SCRIPT_STATES } from '../../hooks/useExternalScript';
import { completeLoading } from 'utils/loaderHelper';

const ConfigProvider = ({ loading, getConfig, config, theme, children }) => {
  const gtmScriptStatus = useGTM(config?.consumer?.analytics);
  let isLoaded = !loading && config;

  if (!loading && !config) {
    getConfig();
  }

  if (config?.consumer?.analytics?.path) {
    isLoaded = isLoaded && gtmScriptStatus !== SCRIPT_STATES.LOADING;
  }

  if (isLoaded) {
    completeLoading();
  }

  return config ? (
    <ThemeProvider theme={createTheme(theme)}>{children}</ThemeProvider>
  ) : null;
};

ConfigProvider.propTypes = {
  config: PropTypes.object,
  getConfig: PropTypes.func,
  loading: PropTypes.bool,
  theme: PropTypes.object,
};

export default ConfigProvider;
